<div class="mt-3 p-3 bg-primary text-white">
  <div class="container clearfix">
    <div class="row">
      <div class="col-9">
        <p>
          &copy; {{copyRight}}
          <br>
          <span class="text-white-50">
            <small>{{'POWERED_BY_CLX_EVENTO'|translate}}</small>
          </span>
        </p>
      </div>
      <div class="col">

        <app-language-selector></app-language-selector>

      </div>
    </div>
  </div>
</div>